import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';

import ContentQRBuilderHeader from '~/components/builder/ContentQRBuilderHeader';
import NameAndOrganizationBlockOldFlow from '~/components/builder/NameAndOrganizationBlockOldFlow';
import PasswordProtectionBlockOldFlow from '~/components/builder/PasswordProtectionBlockOldFlow';
import QrTypeTopCard from '~/components/builder/QrTypeTopCard';
import { SettingsBlock } from '~/components/organisms/editor/SettingsBlock';
import { QR_CODE_BUILDER_EDIT_MODE_PARAM_NAME, QRCODE_DYNAMIC_MICROSITE_TYPE } from '~/constants/qr-code';
import { useAppDispatch } from '~/hooks/useRedux';
import { listOfLinksSlice } from '~/store/reducers/previewScreens/list-of-links';
import { getListOfLinksReducer } from '~/store/reducers/previewScreens/list-of-links/selectors';
import { getQrCodeReducerData } from '~/store/reducers/qr-code/selectors';

import { useQRUrlValidation } from '../../hooks/useQRUrlValidation';

import Appearance from './components/Appearance';
import BasicInformation from './components/BasicInformation';
import Content from './components/Content';

const { actions } = listOfLinksSlice;

export default function ListOfLinksTemplate() {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const isEditPage = !!searchParams.get(QR_CODE_BUILDER_EDIT_MODE_PARAM_NAME);

  const {
    stats: { url, scan, isAutogeneratedUrl, isLimitsEnabled },
  } = useSelector(getListOfLinksReducer);
  const qrCodeState = useSelector(getQrCodeReducerData);

  const urlValidationParams = useQRUrlValidation(url);

  const handleChangeStatsField = (val) => {
    dispatch(actions.setStats(val));
  };

  return (
    <Box display="flex" flexDirection="column" flex={1}>
      <ContentQRBuilderHeader />
      <QrTypeTopCard type={QRCODE_DYNAMIC_MICROSITE_TYPE.LINKS} />
      <Appearance />
      <BasicInformation />
      <Content />
      <NameAndOrganizationBlockOldFlow onChangeName={(val) => dispatch(actions.setTitle(val))} />
      <PasswordProtectionBlockOldFlow />
      <SettingsBlock
        onChange={handleChangeStatsField}
        urlValidationParams={urlValidationParams}
        scanCount={scan}
        isLimitsEnabled={isLimitsEnabled}
        isAutogeneratedUrl={isAutogeneratedUrl}
        defaultUrlValue={url}
        urlFromBE={qrCodeState?.data?.uri || ''}
        isEditPage={isEditPage}
      />
    </Box>
  );
}
